export const RAWMAT_SELECTED = 'PoductProportionForm/RAWMAT_SELECTED';
export const ADD_BUTTON_CLICKED = 'PoductProportionForm/ADD_BUTTON_CLICKED';
export const SUBMIT_PRODUCT_PROPORTION_FORM = 'PoductProportionForm/SUBMIT_PRODUCT_PROPORTION_FORM';
export const SAVE_BUTTON_CLIKED = 'PoductProportionForm/SAVE_BUTTON_CLIKED';
